import { create } from "@/store";
import { WarningContentEnum } from "./warningContentEnum";

export type FeatureStringKey = keyof WarningContentEnum["face"] | keyof WarningContentEnum["microphone"];
export type SpecificFeature = "face" | "microphone";

type Open = <
  T extends SpecificFeature,
  F extends FeatureStringKey = T extends "face" ? FeatureStringKey : keyof WarningContentEnum["microphone"]
>(
  specificFeature?: T,
  stringKey?: F
) => void;

type Store = {
  isOpen: boolean;
  specificFeature: SpecificFeature | null;
  stringKey: FeatureStringKey | null;
  open: Open;
  close: Cb;
};

export const useMonitoringWarningDialog = create<Store>()((set) => ({
  isOpen: false,
  specificFeature: null,
  stringKey: null,
  open(specificFeature, stringKey) {
    set({ isOpen: true, specificFeature, stringKey });
  },
  close() {
    set({ isOpen: false, specificFeature: null, stringKey: null });
  }
}));
